import React, {Suspense, lazy} from 'react';
import {Spin} from 'antd';
import {ROUTE_MYOWN_EFFORT_REPORT} from '../../RoutePathConstant';
import {authLoader} from '../../loader';

const MyOwnEffortReport = lazy(() =>
  import('../../../screens/MyOwnEffortReport')
    .then(module => ({default: module.MyOwnEffortReport})));

const MyOwnEffortReportNavigation = [
  {
    path: ROUTE_MYOWN_EFFORT_REPORT,
    loader: authLoader,
    element: (
      <Suspense fallback={<Spin />}>
        <MyOwnEffortReport />
      </Suspense>
    ),
  },
];

export default MyOwnEffortReportNavigation;
